import React, { Component } from "react";
import { connect } from "react-redux";
import { AuthSingin } from "../../redux/actions/Auth.Action";
import ApiConnect from "../../Utils/ApiConnect";
import { NavLink as Links } from "react-router-dom";
import CryptoJS from "react-native-crypto-js";
class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      company: "",
      remember: "",
      autoLogin: false,
      companylist: [],
      hidecompany: true,
      loading: false,
    };
  }
  componentDidMount = () => {
    const autoLogin = localStorage.AutoLogin || false;
    const loginTry = localStorage.AutoLoginTry || 0;
    if (autoLogin && loginTry < 5) {
      const loginDAta = JSON.parse(
        CryptoJS.AES.decrypt(autoLogin, process.env.REACT_APP_API_KEY).toString(
          CryptoJS.enc.Utf8
        )
      );
      this.setState({
        username: loginDAta.username,
        password: loginDAta.password,
        company: loginDAta.company,
        remember: loginDAta.remember,
      });
      this.props.AuthSingin(
        loginDAta.username,
        loginDAta.password,
        loginDAta.company,
        loginDAta.remember
      );
      localStorage.setItem("AutoLoginTry", loginTry + 1);
    } else {
      localStorage.removeItem("AutoLogin");
    }
  };

  GetCompany = () => {
    ApiConnect.get(
      "/Auth/UserLogin/CompanyList?username=" + this.state.username
    )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({
            companylist: response.data.company,
            hidecompany: response.data.company.length === 1 ? true : false,
            company: response.data.company[0].id,
          });
        } else {
          this.setState({ companylist: [], hidecompany: true });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  setAutoLogin = () => {
    const data = {
      username: this.state.username,
      password: this.state.password,
      company: this.state.company,
      remember: this.state.remember,
    };
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      process.env.REACT_APP_API_KEY
    ).toString();
    localStorage.setItem("AutoLogin", ciphertext);
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.autoLogin) {
      this.setAutoLogin();
    }
    this.props.AuthSingin(
      this.state.username,
      this.state.password,
      this.state.company,
      this.state.remember
    );
  };

  render() {
    return (
      <div className="px-30 w-400px mx-auto">
        <h3 className="header-title">
          <strong>Welcome to NG Admin</strong>
        </h3>
        <p>Sign in by entering information below.</p>
        <form className="form" onSubmit={(e) => this.handleSubmit(e)}>
          <div
            className="form-group"
            style={{
              display: `${this.state.hidecompany ? "none" : "block"}`,
            }}
          >
            <label htmlFor="username">Company</label>
            <select
              className="form-control"
              onChange={(e) => this.setState({ company: e.target.value })}
              value={this.state.company}
            >
              <option value="">Select Company</option>
              {this.state.companylist.map((comp, index) => (
                <option key={index} value={comp.id}>
                  {comp.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              className="form-control input-lg"
              onChange={(e) => this.setState({ username: e.target.value })}
              placeholder="Username"
              value={this.state.username}
              required="required"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control input-lg"
              onChange={(e) => this.setState({ password: e.target.value })}
              placeholder="Password"
              value={this.state.password}
              onFocus={(e) => this.GetCompany()}
              required="required"
            />
          </div>
          <br />
          <div className="form-group flexbox flex-column flex-md-row">
            <label className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                value="1"
                onChange={(e) => this.setState({ remember: e.target.value })}
              />
              <span className="custom-control-description">Remember me</span>
            </label>
            <label className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                value="true"
                onChange={(e) => this.setState({ autoLogin: e.target.value })}
              />
              <span className="custom-control-description">Auto Login</span>
            </label>
            <Links
              to="/Auth/ForgotPassword"
              className="text-muted hover-primary fs-13 mt-2 mt-md-0"
            >
              Forgot password?
            </Links>
          </div>
          <br />
          <div className="form-group">
            <button
              className="btn btn-bold btn-block btn-info w-100 rounded"
              type="submit"
              disabled={this.state.company ? false : true}
            >
              {this.state.loading ? "Loading..." : "Login"}
            </button>
          </div>
        </form>
      </div>
    );
  }
}
export default connect((state) => ({}), { AuthSingin })(LoginPage);
